import Axios from "axios";

import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
const API_CONFIG = getApiConfig();

/* 
    Upload CSV of given type
*/
export const uploadCSV = (file, csvType, callback, urlOverride ) => dispatch => {
    const formData = new FormData();
    formData.append('file', file)

    let defaultUrl = `csv/upload/${csvType}`;

    if (urlOverride) {
        defaultUrl = urlOverride;
    }

    adalApiFetch(Axios, `${API_CONFIG.URL}/${defaultUrl}`, {
        method: "post",
        header: {
            'Content-Type': 'multipart/form-data'
        },
        data: formData
    })
        .then(res => {

            callback(true);
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
};


/* 
    Get CSV of given type as blob
*/
export const getCSVBlob = (csvType, callback, urlOverride ) => dispatch => {
    let defaultUrl = `csv/download?csvType=${csvType}`;

    if (urlOverride) {
        defaultUrl = urlOverride;
    }

    const fileUrl = `${API_CONFIG.URL}/${defaultUrl}`;

    adalApiFetch(Axios, fileUrl, {
        method: "get",
        responseType: "blob"
    })
        .then(res => {
            const blob = res.data;

            callback(blob)
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(null);
        })
};

export const checkStatusCSV = (csvType, callback, urlOverride = null) => dispatch => {

    let defaultUrl = `csv/upload/${csvType}`;

    if (urlOverride != null) {
        defaultUrl = urlOverride;
    }

    const fileUrl = `${API_CONFIG.URL}/${defaultUrl}`;

    adalApiFetch(Axios, fileUrl, {
        method: "get"
    })
        .then(res => {
            const response = res.data;

            callback(response, null)
        }).catch((error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(null, error);
        })
}

